// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .pseudoTerminal {
  background-color: #f6f3f3;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  width: 100%;
  position: relative;
}
.theme-light .pseudoTerminal.maximized {
  position: fixed;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  z-index: 1000;
}
.theme-light .pseudoTerminal h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #ffffff;
}
.theme-light .pseudoTerminal .terminal-header {
  display: flex;
  justify-content: space-between; /* Space between left and right button groups */
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.theme-light .pseudoTerminal .terminal-header .terminal-buttons-left {
  display: flex;
  gap: 8px;
}
.theme-light .pseudoTerminal .terminal-header .terminal-buttons-right {
  display: flex;
  gap: 8px;
}
.theme-light .pseudoTerminal .terminal-header .terminal-button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
}
.theme-light .pseudoTerminal .terminal-header .terminal-button.red {
  background-color: #ff5f56;
}
.theme-light .pseudoTerminal .terminal-header .terminal-button.yellow {
  background-color: #ffbd2e;
}
.theme-light .pseudoTerminal .terminal-header .terminal-button.green {
  background-color: #27c93f;
}
.theme-light .pseudoTerminal .terminal-header .font-button {
  background: none;
  border: none;
  color: #000;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 4px;
}
.theme-light .pseudoTerminal .terminal-header .font-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.theme-light .pseudoTerminal .terminal-header .font-button:focus {
  outline: none;
  background-color: rgba(255, 255, 255, 0.2);
}
.theme-light .pseudoTerminal .terminal-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.theme-light .pseudoTerminal .terminal-body .terminal-output {
  background-color: #000000;
  padding: 10px;
  height: 400px; /* Fixed height */
  overflow-y: auto;
  border: 1px solid;
  border-radius: 5px;
  font-family: "Courier New", Courier, monospace;
  color: #ffffff;
}
.theme-light .pseudoTerminal .terminal-body .terminal-output .terminal-command {
  color: #00ff00;
}
.theme-light .pseudoTerminal .terminal-body .terminal-output .terminal-text {
  color: #ffffff;
  white-space: pre-wrap;
}
.theme-light .pseudoTerminal .terminal-body .terminal-output .terminal-error {
  color: #ff0000;
  white-space: pre-wrap;
}
.theme-light .pseudoTerminal .terminal-input-form {
  display: flex;
}
.theme-light .pseudoTerminal .terminal-input-form input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #333;
  border-radius: 5px 0 0 5px;
  background-color: #1e1e1e;
  color: #ffffff;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}
.theme-light .pseudoTerminal .terminal-input-form input:focus {
  outline: none;
  border-color: #00ff00;
}
.theme-light .pseudoTerminal .terminal-input-form button {
  padding: 10px 20px;
  border: none;
  background-color: #333333;
  color: #ffffff;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}
.theme-light .pseudoTerminal .terminal-input-form button:hover {
  background-color: #555555;
}
.theme-dark .pseudoTerminal {
  background-color: #333;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  width: 100%;
  position: relative;
}
.theme-dark .pseudoTerminal.maximized {
  position: fixed;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  z-index: 1000;
}
.theme-dark .pseudoTerminal h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #ffffff;
}
.theme-dark .pseudoTerminal .terminal-header {
  display: flex;
  justify-content: space-between; /* Space between left and right button groups */
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-buttons-left {
  display: flex;
  gap: 8px;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-buttons-right {
  display: flex;
  gap: 8px;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-button.red {
  background-color: #ff5f56;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-button.yellow {
  background-color: #ffbd2e;
}
.theme-dark .pseudoTerminal .terminal-header .terminal-button.green {
  background-color: #27c93f;
}
.theme-dark .pseudoTerminal .terminal-header .font-button {
  background: none;
  border: none;
  color: #fffef9;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 4px;
}
.theme-dark .pseudoTerminal .terminal-header .font-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.theme-dark .pseudoTerminal .terminal-header .font-button:focus {
  outline: none;
  background-color: rgba(255, 255, 255, 0.2);
}
.theme-dark .pseudoTerminal .terminal-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.theme-dark .pseudoTerminal .terminal-body .terminal-output {
  background-color: #000000;
  padding: 10px;
  height: 400px; /* Fixed height */
  overflow-y: auto;
  border: 1px solid;
  border-radius: 5px;
  font-family: "Courier New", Courier, monospace;
  color: #ffffff;
}
.theme-dark .pseudoTerminal .terminal-body .terminal-output .terminal-command {
  color: #00ff00;
}
.theme-dark .pseudoTerminal .terminal-body .terminal-output .terminal-text {
  color: #ffffff;
  white-space: pre-wrap;
}
.theme-dark .pseudoTerminal .terminal-body .terminal-output .terminal-error {
  color: #ff0000;
  white-space: pre-wrap;
}
.theme-dark .pseudoTerminal .terminal-input-form {
  display: flex;
}
.theme-dark .pseudoTerminal .terminal-input-form input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #333;
  border-radius: 5px 0 0 5px;
  background-color: #1e1e1e;
  color: #ffffff;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}
.theme-dark .pseudoTerminal .terminal-input-form input:focus {
  outline: none;
  border-color: #00ff00;
}
.theme-dark .pseudoTerminal .terminal-input-form button {
  padding: 10px 20px;
  border: none;
  background-color: #333333;
  color: #ffffff;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}
.theme-dark .pseudoTerminal .terminal-input-form button:hover {
  background-color: #555555;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/admin/pseudoTerminal.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,mBAAA;EACA,WAAA;EAEA,kBAAA;AALJ;AAQI;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AANN;AASI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAPN;AAUI;EACE,aAAA;EACA,8BAAA,EAAA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARN;AAUM;EACE,aAAA;EACA,QAAA;AARR;AAWM;EACE,aAAA;EACA,QAAA;AATR;AAYM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAVR;AAYQ;EACE,yBAAA;AAVV;AAaQ;EACE,yBAAA;AAXV;AAcQ;EACE,yBAAA;AAZV;AAgBM;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAdR;AAgBQ;EACE,0CAAA;AAdV;AAiBQ;EACE,aAAA;EACA,0CAAA;AAfV;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBN;AAoBM;EACE,yBAAA;EACA,aAAA;EACA,aAAA,EAAA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,8CAAA;EACA,cAAA;AAnBR;AAqBQ;EACE,cAAA;AAnBV;AAsBQ;EACE,cAAA;EACA,qBAAA;AApBV;AAuBQ;EACE,cAAA;EACA,qBAAA;AArBV;AA0BI;EACE,aAAA;AAxBN;AA0BM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,8CAAA;EACA,eAAA;AAxBR;AA0BQ;EACE,aAAA;EACA,qBAAA;AAxBV;AA4BM;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,8CAAA;EACA,eAAA;AA1BR;AA4BQ;EACE,yBAAA;AA1BV;AD5GI;ECjBA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,mBAAA;EACA,WAAA;EAEA,kBAAA;AA6HJ;AA1HI;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AA4HN;AAzHI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AA2HN;AAxHI;EACE,aAAA;EACA,8BAAA,EAAA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA0HN;AAxHM;EACE,aAAA;EACA,QAAA;AA0HR;AAvHM;EACE,aAAA;EACA,QAAA;AAyHR;AAtHM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAwHR;AAtHQ;EACE,yBAAA;AAwHV;AArHQ;EACE,yBAAA;AAuHV;AApHQ;EACE,yBAAA;AAsHV;AAlHM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAoHR;AAlHQ;EACE,0CAAA;AAoHV;AAjHQ;EACE,aAAA;EACA,0CAAA;AAmHV;AA9GI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAgHN;AA9GM;EACE,yBAAA;EACA,aAAA;EACA,aAAA,EAAA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,8CAAA;EACA,cAAA;AA+GR;AA7GQ;EACE,cAAA;AA+GV;AA5GQ;EACE,cAAA;EACA,qBAAA;AA8GV;AA3GQ;EACE,cAAA;EACA,qBAAA;AA6GV;AAxGI;EACE,aAAA;AA0GN;AAxGM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,8CAAA;EACA,eAAA;AA0GR;AAxGQ;EACE,aAAA;EACA,qBAAA;AA0GV;AAtGM;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,8CAAA;EACA,eAAA;AAwGR;AAtGQ;EACE,yBAAA;AAwGV","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.pseudoTerminal {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-top: 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    // margin-top: 20px;\n    // padding: 20px;\n    border-radius: 10px;\n    width: 100%; // Ensures full width\n    // max-width: 800px; // Remove or comment out to allow full width\n    position: relative;\n    // border-style: 2px solid themed(\"borderColor\");\n\n    &.maximized {\n      position: fixed;\n      top: 10%;\n      left: 10%;\n      width: 80%;\n      height: 80%;\n      z-index: 1000;\n    }\n\n    h2 {\n      text-align: center;\n      margin-bottom: 20px;\n      color: #ffffff;\n    }\n\n    .terminal-header {\n      display: flex;\n      justify-content: space-between; /* Space between left and right button groups */\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 10px;\n\n      .terminal-buttons-left {\n        display: flex;\n        gap: 8px;\n      }\n\n      .terminal-buttons-right {\n        display: flex;\n        gap: 8px;\n      }\n\n      .terminal-button {\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        cursor: pointer;\n\n        &.red {\n          background-color: #ff5f56;\n        }\n\n        &.yellow {\n          background-color: #ffbd2e;\n        }\n\n        &.green {\n          background-color: #27c93f;\n        }\n      }\n\n      .font-button {\n        background: none;\n        border: none;\n        color: themed(\"textColor\");\n        cursor: pointer;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 5px;\n        border-radius: 4px;\n\n        &:hover {\n          background-color: rgba(255, 255, 255, 0.1);\n        }\n\n        &:focus {\n          outline: none;\n          background-color: rgba(255, 255, 255, 0.2);\n        }\n      }\n    }\n\n    .terminal-body {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n\n      .terminal-output {\n        background-color: #000000;\n        padding: 10px;\n        height: 400px; /* Fixed height */\n        overflow-y: auto;\n        border: 1px solid themed(\"borderColor\");\n        border-radius: 5px;\n        // margin-bottom: 10px;\n        font-family: 'Courier New', Courier, monospace;\n        color: #ffffff;\n\n        .terminal-command {\n          color: #00ff00;\n        }\n\n        .terminal-text {\n          color: #ffffff;\n          white-space: pre-wrap;\n        }\n\n        .terminal-error {\n          color: #ff0000;\n          white-space: pre-wrap;\n        }\n      }\n    }\n\n    .terminal-input-form {\n      display: flex;\n\n      input {\n        flex: 1;\n        padding: 10px;\n        border: 1px solid #333;\n        border-radius: 5px 0 0 5px;\n        background-color: #1e1e1e;\n        color: #ffffff;\n        font-family: 'Courier New', Courier, monospace;\n        font-size: 14px;\n\n        &:focus {\n          outline: none;\n          border-color: #00ff00;\n        }\n      }\n\n      button {\n        padding: 10px 20px;\n        border: none;\n        background-color: #333333;\n        color: #ffffff;\n        cursor: pointer;\n        border-radius: 0 5px 5px 0;\n        font-family: 'Courier New', Courier, monospace;\n        font-size: 14px;\n\n        &:hover {\n          background-color: #555555;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
